import type { components } from "~/api/openapi.gen.ts";

export type MonthlyClosingRead = components["schemas"]["MonthlyClosingMonthResource"];
export type MonthlyClosingStaffingPart = components["schemas"]["MonthlyClosingStaffingResource"];
export type MonthlyClosingNonProjectPart = components["schemas"]["MonthlyClosingPartResource"];
export type MonthlyClosingStaffingUnlock = MonthlyClosingStaffingPart["unlocks"][number];

/** Each month is `YYYY-MM`, the newest first. */
export type OpenMonthlyClosingMonthsRead = {
	months: string[];
};

export type MonthlyClosingScope =
	| { scope: "all" }
	| { scope: "nonProject" }
	| { scope: "project"; projectId: string }
	| { scope: "staffings"; staffingIds: string[] };

/** A close that the user asked for, before the confirmation. `label` names the scope for the user. */
export type MonthlyClosingCloseRequest = {
	label: string;
	scope: MonthlyClosingScope;
};

export type MonthlyClosingReopenPart =
	| { part: "staffing"; staffingId: string }
	| { part: "nonProject" };

/** A reopen that the user asked for, before the confirmation. `label` names the part for the user. */
export type MonthlyClosingReopenRequest = {
	label: string;
	part: MonthlyClosingReopenPart;
};

export type CloseMonthlyClosingPayload = MonthlyClosingScope & {
	month: string;
};

/** The `rule` of each refused close, on `staffingIds.N`, `projectId` or `month`, by scope. */
export const CLOSE_REFUSED_RULE = "monthlyClosingIsClosableRule";
